'use client';

import React from 'react';
import InlineAlert from 'src/components/primitives/InlineAlert/InlineAlert';
import TextButton from 'src/components/primitives/TextButton/TextButton';
import useAccountData from 'src/hooks/useAccountData';
import useModal from 'src/components/Modals/hooks/useModal';

const CustomMaxLeverageCta = () => {
	const currentAccount = useAccountData();
	const hasCustomMaxMarginRatio =
		!!currentAccount?.client?.getUserAccount()?.maxMarginRatio;
	const { show } = useModal();

	const goToMarginSettings = () => {
		show({ type: 'settings', props: { view: 'margin' } });
	};

	if (!hasCustomMaxMarginRatio) return;

	return (
		<InlineAlert
			variant="warning"
			title="Your custom max leverage settings may affect these amounts"
		>
			<TextButton size="sm" onClick={goToMarginSettings}>
				Click here to update
			</TextButton>
		</InlineAlert>
	);
};

export default CustomMaxLeverageCta;
